// ------------------------------------------------
// DUPLICATED BETWEEN FRONTEND, BACKEND/ASSETS, AND MARKETING REPO!
// Copy any changes to this file to the corresponding amplitude.ts file in
// the other projects!
// ------------------------------------------------
const SESSION_ID_KEY = "CC_AMPLITUDE_SESSION_ID"
const LAST_ACTIVITY_KEY = "CC_AMPLITUDE_SESSION_LAST_ACTIVITY"

export function getAmplitudeSessionId(): number | null {
  if (typeof sessionStorage === "undefined") return null

  const sessionIdString = sessionStorage.getItem(SESSION_ID_KEY)
  if (!sessionIdString) return null

  // Expire the sessionId after 8 hours of inactivity.
  const lastActivityString = sessionStorage.getItem(LAST_ACTIVITY_KEY)
  if (!lastActivityString) return null
  const lastActivity = parseInt(lastActivityString)
  if (Date.now() - lastActivity > 8 * 60 * 60 * 1000) return null

  // Record this activity.
  sessionStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString())

  return parseInt(sessionIdString)
}

export function getOrCreateAmplitudeSessionId(): number {
  const existing = getAmplitudeSessionId()
  if (existing === null) {
    const newSessionId = Date.now()
    // Without sessionStorage we can't persist it, but callers still get a usable
    // session ID rather than an exception.
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(SESSION_ID_KEY, newSessionId.toString())
      sessionStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString())
    }
    return newSessionId
  } else {
    return existing
  }
}
